//@ts-check
import jquery from 'jquery';
import RateSwitcher from '../ui/RateSwitcher.js';
import MobileOverflowShadowInit from './MobileOverflowShadowInit.js';
import Spinner from './Spinner.js';

/**
 * @type {Spinner}
 */
let spinner = null;

const updateRateTables = function(callbacks) {
    const zipCodeUpdate = jquery('#zip-code-update');
    //@ts-ignore
    const parsleyInstance = zipCodeUpdate.parsley();

    if (parsleyInstance.isValid()) {
        const zipCodeEntered = zipCodeUpdate.val();
        jquery('.dimmer').toggleClass('active');


        jquery.each(callbacks, function(propertyName, valueOfProperty) {
            spinner.loading();
            valueOfProperty(zipCodeEntered);
        });

        /* update the zipCodeMessage to reflect zip code entered, replaces the 5-digit zip code numbers with zip code entered */
        jquery('#zipCodeMessage').html(function(i, txt) {
            return txt.replace(/\d{5}/, /**@type {String}*/(zipCodeEntered));
        });
    }
};

export const api = {
    /* Initialize rate submit form to do an asynchronous update of all rate tables. */
    init () {
        const callbacks = [];
        /* Note that all rate table wrappers have come back in the initial page load,
         * so we don't need to recalculate as long as we look them up by ID on each submit.
         */
        const $rateTableWrappers = jquery('.rate-table-wrapper');

        $rateTableWrappers.each(function() {
            const wrapperId = jquery(this).attr('id');
            callbacks.push(function (zip) {
                jquery.post(
                    '/post/Rate/GetRateTableFromId',
                    {
                        zip,
                        rateTableId: wrapperId,
                        scController: 'Rate',
                        scAction: 'GetRateTableFromId'
                    },
                    function (data) {
                        setTimeout(() => {
                            spinner.loaded('Rates have loaded.');
                            jquery('#' + wrapperId).html(data);
                            RateSwitcher.init();
                            MobileOverflowShadowInit.init();
                        }, 350);

                    });
            });
        });

        /* Invoke the callbacks against all the tables when the form is submitted. */
        jquery('#rateZipCodeForm').submit(function(e) {
            e.preventDefault();
            updateRateTables(callbacks);
            /* Trigger a synthetic click on each table for SiteCatalyst tracking of the user interaction with the form. */
            jquery('.rateUpdateSuccess').click();
        });

        const formSpinner = document.getElementById('rateZipCodeFormSpinner');
        if (formSpinner) {
            spinner = new Spinner(formSpinner);
        }
    }
};
export default api;
